import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCloseButton from 'components/common/FalconCloseButton';
import IconButton from 'components/common/IconButton';

import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import PropTypes from 'prop-types';
import { default as React, useState } from 'react';
import { Badge, Button, Card, Col, ListGroup, Modal, Row, Table } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import useToken from '../../hooks/useToken';
import SeccionConfiguracionDatosNube from './SeccionConfiguracionDatosNube';
import SeccionUsuariosNubeAkasia from './SeccionUsuariosNubeAkasia';
import { useToast } from 'context/providers/ToastProvider';

const SeccionDatosCliente = ({
    idLicencia,
    licencias,
    getInformacionDetalladaLicenciaByID,
    usuariosNube,
    setUsuariosNube
}) => {

    const [licenciasRelacionadas, setLicenciasRelacionadas] = useState([]);
    const [showModalRelacionadas, setShowModalRelacionadas] = useState(false);
    const [clientes, setClientes] = useState([]);
    const [showModalCambiarCliente, setShowModalCambiarCliente] = useState(false);

    const { showErrorToast, showSuccessToast } = useToast();

    /**
     * AUTENTICACION
     */
    const { token, setToken } = useToken();

    /**
     * Columnas Para Los clientes Que se Cambiaran
     */
    const columns = [
        {
            accessor: 'idClienteAkasia',
            Header: 'ID',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { idClienteAkasia } = rowData.row.original;
                return (<b>{idClienteAkasia}</b>)
            }
        },
        {
            accessor: 'vNombre',
            Header: 'Nombre Cliente',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vNombre } = rowData.row.original;
                return <span className="d-inline-block text-truncate" style={{ maxWidth: '250px' }}> {vNombre}</span>
            }
        },
        {
            accessor: 'vPais',
            Header: 'Pa\u00EDs',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vPais } = rowData.row.original;
                return <span className="d-inline-block text-truncate" style={{ maxWidth: '150px' }}>{vPais}</span>
            }
        },
        {
            accessor: 'vEstadoDepProv',
            Header: 'vEstadoDepProv',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vEstadoDepProv } = rowData.row.original;
                return <span className="d-inline-block text-truncate" style={{ maxWidth: '150px' }}>{vEstadoDepProv}</span>
            }
        },

        {
            accessor: 'none',
            Header: '',
            Cell: rowData => {
                const { idClienteAkasia, vNombre } = rowData.row.original;
                return (
                    <Row className="flex-end-center">
                        <Col xs="auto" >
                            <Button variant="light" size="sm" onClick={() => { cambiarCliente(idClienteAkasia, vNombre) }} className="border-300 text-600">
                                Seleccionar
                            </Button>
                        </Col>
                    </Row>
                );
            }
        }
    ];

    /**
     * Este metodo obtiene las licencias relacionadas a la Nube
     * @param {any} vUUIDEmpresa
     */
    const obtenerLicenciasRelacionadas = async (vUUIDEmpresa) => {
        console.log(vUUIDEmpresa);
        setShowModalRelacionadas(true);
        const response = await fetch("/api/licencia/obtenerlicenciasrelacionadas/?vUUIDEmpresa=" + vUUIDEmpresa, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data["table1"]);
            setLicenciasRelacionadas(data["table1"])

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };



    /**
     * Este metodo aumenta el numero de dias del periodo de prueba
     * @param {any} idClienteAkasia
     * @param {any} vNombreClienteNuevo
     */
    const cambiarCliente = async (idClienteAkasia, vNombreClienteNuevo) => {
        const response = await fetch("/api/licencia/cambiarCliente/?id=" + idLicencia + "&idClienteAkasia=" + idClienteAkasia + "&vClienteNuevo=" + encodeURIComponent(vNombreClienteNuevo) + "&vClienteAnterior=" + encodeURIComponent(licencias.vNombre) + "_" + encodeURIComponent(licencias.vApellidos), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {

            const data = await response.json();
            console.log("data: ", data);

            if (data.iResponseType == 1) {

                var detalles = JSON.parse(data.detalles);
                detalles = detalles[0];
                console.log("detalles: ", detalles);

                licencias.idClienteAkasia = detalles.idClienteAkasia;
                licencias.vNombre = detalles.vNombre;
                licencias.vApellidos = detalles.vApellidos;
                licencias.vEmail = detalles.vEmail;
                licencias.vTelefonoPersonal = detalles.vTelefonoPersonal;
                licencias.vUpdatedUser = detalles.vUpdatedUser;

                showSuccessToast(data.vMessage);
            }
            else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalCambiarCliente(false);
    };

    /**
     * Obtener Servidores VUUID
     */
    const obtenerListaClientes = async () => {
        const response = await fetch("/api/cliente/obtenerlistaclientes", {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data["table1"]);
            setClientes(data["table1"])

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };



    return (
        <>
            <Card className="mb-3 fs--1">
                <Card.Header>
                    <Row>
                        <Col xs="auto" className="mt-2">
                            <h6 className="text-uppercase text-600">
                                CLIENTE
                                <FontAwesomeIcon icon="user" className="ms-2" />
                            </h6>
                            {licencias.bIsActive &&
                                <IconButton
                                    onClick={() => { setShowModalCambiarCliente(true); obtenerListaClientes() }}
                                    iconClassName="fs--2 me-1"
                                    variant="falcon-default"
                                    size="sm"
                                    icon="pencil-alt"
                                >
                                    Cambiar
                                </IconButton>
                            }
                        </Col>
                        <Col>
                            <h5 className="mb-2">
                                <Link to={"/clientes/detalle/" + licencias.idClienteAkasia}> {licencias.vNombre}</Link>
                            </h5>
                            <h5 className="mb-2">
                                <Link to={"/clientes/detalle/" + licencias.idClienteAkasia}> {licencias.vApellidos}</Link>
                            </h5>
                            <h6>
                                <a href={"mailto:" + licencias.vEmail}>{licencias.vEmail}</a>
                            </h6>
                            <h6>
                                <a href={"https://wa.me/" + licencias.vTelefonoPersonal} target="_blank" rel="noreferrer">
                                    <img title="Enviar WhatsApp" src="/img/whatsapp20.png"></img > {licencias.vTelefonoPersonal}
                                </a>
                            </h6>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body className="border-top">

                    <Table responsive striped hover size="sm" >
                        <tbody>
                            {licencias.idCatTipoLicencia != 3 &&
                                <>
                                    <tr>
                                        <td>NOMBRE DE EMPRESA:</td>
                                        <td>{licencias.vNombreEmpresa}</td>
                                    </tr>
                                    <tr>
                                        <td>GIRO COMERCIAL:</td>
                                        <td>{licencias.vGiroComercial}</td>
                                    </tr>
                                </>
                            }
                        </tbody>
                    </Table>

                    <ListGroup variant="flush">

                        {licencias.idCatTipoLicencia == 3 &&
                            <>

                                <SeccionConfiguracionDatosNube
                                    idLicencia={idLicencia}
                                    licencias={licencias}
                                    getInformacionDetalladaLicenciaByID={getInformacionDetalladaLicenciaByID}
                                ></SeccionConfiguracionDatosNube>

                                <SeccionUsuariosNubeAkasia
                                    idLicencia={idLicencia}
                                    licencias={licencias}
                                    getInformacionDetalladaLicenciaByID={getInformacionDetalladaLicenciaByID}
                                    usuariosNube={usuariosNube}
                                    setUsuariosNube={setUsuariosNube}
                                ></SeccionUsuariosNubeAkasia>

                                <hr></hr>
                                {licencias.bIsActive &&
                                    <IconButton
                                        variant="link"
                                        iconClassName="fs--2 ms-1"
                                        icon="chevron-right"
                                        className="d-block w-100"
                                        iconAlign="right"
                                        onClick={() => { obtenerLicenciasRelacionadas(licencias.vUUIDEmpresa); }}
                                    >
                                        Ver licencias relacionadas con la Nube
                                    </IconButton>
                                }
                            </>
                        }
                    </ListGroup>
                </Card.Body>
            </Card>

            {
                showModalRelacionadas &&
                <Modal
                    show={showModalRelacionadas}
                    onHide={() => setShowModalRelacionadas(false)}
                    size="lg"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title>Licencias relacionadas por UUID Empresa. </Modal.Title>
                        <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalRelacionadas(false); }} />

                    </Modal.Header>
                    <Modal.Body>
                        <p>Se enlistan las licencias que est&aacute;n relacionadas con el n&uacute;mero UUID Empresa.</p>
                        <p>
                            <strong>
                                UUID EMPRESA: {licencias.vUUIDEmpresa}
                            </strong>
                        </p>
                        <Table responsive striped hover size="sm">
                            <tbody>
                                <tr>
                                    <td>ID</td>
                                    <td>TIPO</td>
                                    <td>ESTADO</td>
                                    <td>LICENCIA</td>
                                    <td>&Uacute;LTIMA CONEXI&Oacute;N</td>
                                </tr>
                                {licenciasRelacionadas.map((relacion, index) => {
                                    return (
                                        <tr key={index} >
                                            <td>{relacion.idLicencia}</td>
                                            <td>
                                                {relacion.vDescripcionTipo}
                                            </td>
                                            <td>
                                                {relacion.bCancelado ?
                                                    (
                                                        <Badge bg="danger" className="me-2 dark__bg-dark"> CANCELADA </Badge>
                                                    ) : (
                                                        relacion.bIsPeriodoPrueba ?
                                                            (
                                                                <Badge bg="danger" className="me-2 dark__bg-dark"> PRUEBA </Badge>

                                                            ) : (

                                                                <Badge bg="success" className="me-2 dark__bg-dark"> ACTIVA </Badge>
                                                            )
                                                    )
                                                }
                                            </td>
                                            <td>
                                                <Link to={"/licencias/detalle/" + relacion.idLicencia}>
                                                    {relacion.vUUIDLicencia}
                                                </Link>
                                            </td>
                                            <td>
                                                {relacion.dUltimaConexion}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => { setShowModalRelacionadas(false); }} variant='primary' >Cerrar</Button>
                    </Modal.Footer>

                </Modal>
            }


            {showModalCambiarCliente &&
                <Modal
                    show={showModalCambiarCliente}
                    onHide={() => setShowModalCambiarCliente(false)}
                    size="lg"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title>Cambiar cliente Akasia. </Modal.Title>
                        <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalCambiarCliente(false); }} />
                    </Modal.Header>
                    <Modal.Body style={{ padding: "0px" }}>
                        <AdvanceTableWrapper
                            columns={columns}
                            data={clientes}
                            sortable
                            pagination
                            perPage={10}
                        >
                            <Card>
                                <Card.Header>
                                </Card.Header>
                                <Card.Body className="p-0">
                                    <Row className="flex-end-center mb-3">
                                        <Col sm={8} lg={4}>
                                            <AdvanceTableSearchBox table />
                                        </Col>
                                    </Row>
                                    <AdvanceTable
                                        table
                                        headerClassName="bg-200 text-900 text-nowrap align-middle"
                                        rowClassName="align-middle white-space-nowrap"
                                        tableProps={{
                                            size: 'sm',
                                            striped: true,
                                            hover: true,
                                            className: 'fs--1 mb-0 overflow-hidden'
                                        }}
                                    />

                                </Card.Body>
                                <Card.Footer>

                                    <AdvanceTableFooter
                                        rowCount={licencias.length}
                                        table
                                        rowInfo
                                        navButtons
                                        rowsPerPageSelection
                                    />
                                </Card.Footer>
                            </Card>

                        </AdvanceTableWrapper>
                    </Modal.Body>

                </Modal>
            }

        </>
    )
}

SeccionDatosCliente.propTypes = {
    setShowModalCambiarCliente: PropTypes.func,
    hardware: PropTypes.array,
    idLicencia: PropTypes.string,
    licencias: PropTypes.object,
    getInformacionDetalladaLicenciaByID: PropTypes.func,
    usuariosNube: PropTypes.array,
    setUsuariosNube: PropTypes.func,
    infoSuscripcion: PropTypes.object
};

export default SeccionDatosCliente;